import { call, put, takeLatest } from 'redux-saga/effects';

import * as nftActions from './nftActions.js';
import { updateNFTApiCall } from './nftAPI.js';

function* updateNFTSaga({ payload }) {
  try {
    const { data } = yield call(updateNFTApiCall, payload);
    yield put(nftActions.nftUpdateStore(data));
  } catch (error) {
    yield put(nftActions.nftUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* nftWatcher() {
  yield takeLatest(nftActions.nftUpdateRequest.type, updateNFTSaga);
}
